import { BehaviorSubject } from "rxjs";

import TWEEN from "@tweenjs/tween.js";
import { vec2, mat4 } from "gl-matrix";

import Sprite from "../sprite";
import { loadTexture } from "../helpers/webgl-helpers";

import spriteSheetImageUrl from "../../assets/sprites/chara4.png";
import spriteSheetNormalImageUrl from "../../assets/sprites/chara4-n.png";

import { Directions } from "../interfaces";

export default class KingPresident extends Sprite {
  tileIndex: number;
  tileSize: vec2;
  tileSetDimensions: vec2;
  spriteAnimationTween: TWEEN.Tween;
  texture: WebGLTexture | null;
  textureUrl: string;
  normalTexture: WebGLTexture | null;
  animations: { [key: string]: number[] };
  animationName$: BehaviorSubject<string>;
  modelMatrix: number[];
  name: string;
  animationSpeed = 550;

  constructor(gl: WebGLRenderingContext, programName: string) {
    super(gl, programName);
    this.modelMatrix = <number[]>mat4.create();
    this.tileSize = [26, 36];
    this.tileSetDimensions = [312, 288];
    this.tileIndex = 0;
    this.textureUrl = spriteSheetImageUrl;
    this.name = "king-president";
    this.animations = {
      left: [12, 13, 14],
      up: [36, 37, 38],
      down: [0, 1, 2],
      right: [24, 25, 26],
      downIdle: [1],
      upIdle: [37],
      leftIdle: [13],
      rightIdle: [25]
    };
    this.setScale(this.tileSize[0] / this.tileSize[1], 1);
    this.setDirection(Directions.DownIdle);
  }

  async load() {
    const { gl } = this;
    this.texture = await loadTexture(gl, spriteSheetImageUrl);
    this.normalTexture = await loadTexture(gl, spriteSheetNormalImageUrl);
    return true;
  }
}
